import {
  SET_PAYSLIP_DETAIL,
  SET_PAYSLIP_OVERVIEW,
  SET_PAYSLIP_YEAR,
  EXPORT_PAYSLIP_DETAIL,
} from './constants';

const initialState = {
  yearsList: [],
  overview: {},
  paidDatesList: [],
  detail: {},
  link: '',
};

const payslipReducers = (state = initialState, action = {}) => {
  const { type, payload } = action;
  switch (type) {
    case SET_PAYSLIP_YEAR:
      state = {
        ...state,
        yearsList: payload,
      };
      break;
    case SET_PAYSLIP_OVERVIEW:
      state = {
        ...state,
        overview: payload.overview,
        paidDatesList: payload.paidDatesList,
      };
      break;
    case SET_PAYSLIP_DETAIL:
      state = {
        ...state,
        detail: payload,
      };
      break;
    case EXPORT_PAYSLIP_DETAIL:
      state = {
        ...state,
        file: payload,
      };
      break;
    default:
      break;
  }
  return state;
};

export default payslipReducers;
